const ProjectName = 'TTSH';
const ipAddr = 'app.ttsh.hcc.edu.tw/study-0.0.1-TTSH';
// const ipAddr = '52.197.196.72:8092/study-0.0.1-TTSH';
// const ipAddr = '192.168.50.29:8096';
// const ipAddr = 'localhost:8087';

var getAPIURL = function(){
	sessionStorage.setItem('ipAddr', ipAddr)

	// return "http://localhost:8086";
	// return "http://192.168.100.7:8087";
	// return "http://52.194.186.142:8087";
	// return 'http://' + ipAddr;
	return 'https://' + ipAddr;
	
	// HTTPS SERVER
	// return "https://chihta-software.com/study-0.0.1-SNAPSHOT"; //更新版本號
	// return "https://13.114.173.137/study-0.0.1-SNAPSHOT";
}

const CONFIG = {

	/**

	* [API_URL]

	* @description: 全站發 api 的 endpoint

	*/
	PROJECT_NAME:ProjectName,
	API_URL: getAPIURL(),

}

export { CONFIG };
